<template>
    <multiselect
        v-model="paymentMethod"
        :options="paymentMethods"
        track-by="key"
        label="value"
        :multiple="false"
        :allowEmpty="!!allowEmpty"
        placeholder="Método de Pago"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @select="$emit('select')"
        @input="notifyChange">
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {paymentMethods} from '@/constants/payment-constants';

    export default {
        name: "PaymentMethodSelector",
        components: {
            Multiselect
        },
        props: {
            value: String,
            allowEmpty: Boolean
        },
        data: function () {
            return {
                paymentMethod: !!this.value ? this.findOptionByKey(this.value) : null
            }
        },
        computed: {
            paymentMethods() {
                return paymentMethods;
            }
        },
        methods: {
            findOptionByKey(key) {
                return paymentMethods.find(method => (method.key === key));
            },
            notifyChange(paymentMethod) {
                this.$emit('input', (!!paymentMethod ? paymentMethod.key : null));
            }
        },
        watch: {
            value: function () {
                if (!!this.value) {
                    this.paymentMethod = this.findOptionByKey(this.value);
                }
            }
        }
    }
</script>

<style scoped>

</style>